const addImageDimensions = (url, width, height) => {
    if (typeof url !== "string") {
        return url;
    }

    // Parse the URL
    const parsedUrl = new URL(url);

    // Check if URL is from Shopify or Sanity, adjust accordingly
    if (url.includes("shopify")) {
        // Shopify uses `width` and `height` as parameters
        parsedUrl.searchParams.set("width", width);
        if (height) {
            parsedUrl.searchParams.set("height", height);
        }
    } else if (url.includes("sanity")) {
        // Sanity uses `w` and `h` for width and height
        parsedUrl.searchParams.set("w", width);
        if (height) {
            parsedUrl.searchParams.set("h", height);
        }
    } else if (url.includes("assets.sealskincovers") || url.includes("assets-stg.sealskincovers")) {
        // Assets.sealskincovers uses `width` and `height` as parameters
        const bucketName = parsedUrl.hostname;
        const imagePath = parsedUrl.pathname.replace("/", "");
        const domain = 'https://d2p6ybb0fsrh2s.cloudfront.net';

        const objToBase64 = {
            bucket: bucketName,
            key: imagePath,
            edits: {
                resize: {
                    width: width,
                    ...(height ? { height: height } : {})
                },
                toFormat: "avif"
            }
        }
        const base64String = btoa(JSON.stringify(objToBase64));
        const base64Url = `${domain}/${base64String}`;
        return base64Url;
    }


    // Return the modified URL
    return parsedUrl.toString();
};

export default addImageDimensions;